import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (Id) {
  const { isRequestSuccessed, exec, rst } = useRequest({
    url: '',
    name: 'DELETE_BLOCKED_DEPARTMENT',
    method: 'DELETE',
  });

  useEffect(() => {
    if (Id) {
      exec(`/api/blocked_department/${Id}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Id]);

  return [isRequestSuccessed, rst];
});
